import { useState } from 'react'

import { useDateFilterWriteContext } from '@context/DateFilterContext'

import { PageQuery, SortOrder } from '@utils/ApiClient'

import { FilterQueryProps } from '@model/FilterFields'

const initialQuery = {}

export const useCampaignRebateSearch = (sort: { sort?: string; sortOrder?: SortOrder }) => {
  const { clearFilter } = useDateFilterWriteContext()
  const [search, setSearch] = useState<FilterQueryProps>(initialQuery)
  const [pageQuery, setPageQuery] = useState<PageQuery>({
    sort: sort.sort,
    sortOrder: sort.sortOrder,
  })

  return {
    clearSearch: (cb: () => void) => {
      cb()
      setSearch(initialQuery)
      clearFilter()
    },
    search,
    setSearch,
    pageQuery,
    setPageQuery,
  }
}
